module.exports = __webpack_public_path__ + "static/img/ext5.484e88ae.jpg";